import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import HeaderPage from "../components/HeaderPage";
import Notification from "../components/Notification";

import { useAuth } from "../context/AuthContext";
import { useNotas } from "../context/NotasContext";
import { useUsers } from "../context/UsersContext";
import { useIndicadores } from "../context/IndicadoresContext";

import IndicadoresForm from "../components/Indicadores/IndicadoresForm";
import IndicadoresViewer from "../components/Indicadores/IndicadoresViewerAdmin";


const IndicadoresPage = () => {
  const { user } = useAuth();
  const { periodos, fetchPeriodos, getAsignaturasSalon, asignaturasSalon, loadingAsignaturas } = useNotas();
  const {
    asignaturas,
    fetchAsignaturas,
    salones,
    fetchSalones,
    salonGrado,
    fetchSalonForDirector
  } = useUsers();

  const {
    createIndicadorData,
    fetchIndicadoresBySalonYPeriodo,
    updateIndicadorData,
    deleteIndicadorData,
    loading,
  } = useIndicadores();

  const [periodoId, setPeriodoId] = useState("");
  const [indicadores, setIndicadores] = useState({});
  const [indicadoresGuardados, setIndicadoresGuardados] = useState([]);
  const [notification, setNotification] = useState(null);
  const [errores, setErrores] = useState([]); // ← aquí guardaremos los asignatura_id con errores
  const [salonId, setSalonId] = useState("");


  const closeNotification = () => setNotification(null);

  const grado = salonGrado?.salon_grado?.toLowerCase();
  const esPreescolar = ["parvulos", "prejardin", "jardin", "transicion"].includes(grado);

  // Para admin: obtener el grado del salón seleccionado
  const salonSeleccionado = salones.find((s) => s.id === parseInt(salonId));
  const gradoAdmin = salonSeleccionado?.grado
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  const esPreescolarAdmin = ["parvulos", "prejardin", "jardin", "transicion"].includes(gradoAdmin);

  // ✅ CARGAR ASIGNATURAS DEL SALÓN cuando cambie el salón o cuando sea profesor
  useEffect(() => {
    if (user?.rol_id === 2 && salonGrado?.salon_id) {
      // Profesor: cargar asignaturas de su salón
      getAsignaturasSalon(salonGrado.salon_id);
    } else if (user?.rol_id === 1 && salonId) {
      // Admin: cargar asignaturas del salón seleccionado
      getAsignaturasSalon(salonId);
    }
  }, [salonGrado?.salon_id, salonId, user?.rol_id, getAsignaturasSalon]);

  // ✅ DETERMINAR QUÉ ASIGNATURAS MOSTRAR
  const asignaturasDelSalon = user?.rol_id === 2
    ? asignaturasSalon // Profesor usa asignaturas del salón
    : user?.rol_id === 1 && esPreescolarAdmin
    ? asignaturasSalon.filter(asig => 
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].includes(asig.asignatura_id)
      )
    : asignaturasSalon; // Admin preescolar o primaria

  useEffect(() => {
    if (user?.rol_id === 2 || user?.rol_id === 1) {
      fetchPeriodos();
      fetchAsignaturas();
      if (user?.rol_id === 1) {
        fetchSalones(); 
      }
      if (user?.rol_id === 2 && !salonGrado) {
        fetchSalonForDirector(); // solo si no lo tiene
      }
    }
  }, [user]);

  useEffect(() => {
    if (user?.rol_id === 2) {

      const fetchIndicadoresByPeriodo = async () => {
        if (periodoId && salonGrado?.salon_id) {
          try {
            const data = await fetchIndicadoresBySalonYPeriodo(periodoId, salonGrado.salon_id);
            setIndicadoresGuardados(data || []);
  
            const mapa = {};
            data.forEach((item) => {
              mapa[item.asignatura_id] = { id: item.id, descripcion: item.descripcion };
            });
            setIndicadores(mapa);
          } catch (error) {
          }
        }
      };
    
      fetchIndicadoresByPeriodo();
    }

    if (user?.rol_id === 1) {
      const fetchIndicadoresByPeriodo = async () => {
        if (periodoId && salonId) {
          try {
            const data = await fetchIndicadoresBySalonYPeriodo(periodoId, salonId);
            setIndicadoresGuardados(data || []);
          } catch (error) {
          }
        }
      };
    
      fetchIndicadoresByPeriodo();
    }
  }, [periodoId, fetchIndicadoresBySalonYPeriodo, salonGrado?.salon_id, salonId]); // <- aquí está el problema
  
  

  const handleChange = (asignaturaSalonId, value) => {
    setIndicadores((prev) => ({
      ...prev,
      [asignaturaSalonId]: value,
    }));
  };
  
  const handleSubmit = async () => {
  if (!periodoId) {
    setNotification({
      type: "error",
      message: "Debe seleccionar un periodo antes de guardar.",
    });
    return;
  }

  const tieneContenidoReal = (html) => {
    if (!html || typeof html !== "string") return false;
    const sinEtiquetas = html
      .replace(/<(ul|ol|li|br|p|div|span)[^>]*>/gi, "")
      .replace(/<\/(ul|ol|li|br|p|div|span)>/gi, "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, "")
      .replace(/\s+/g, "");
    return sinEtiquetas.length > 0;
  };

  // 🔥 CAMBIO: Construir el array correctamente con asignatura_salon_id
  const indicadoresArray = asignaturasDelSalon.map((asigSalon) => ({
    asignatura_salon_id: asigSalon.asignatura_salon_id, // ✅ Usar asignatura_salon_id
    periodo_id: periodoId,
    descripcion: indicadores[asigSalon.asignatura_salon_id] || "",
  }));

  // Validar que todos tengan contenido
  const faltantes = indicadoresArray.filter(
    (ind) => !tieneContenidoReal(ind.descripcion)
  );

  if (faltantes.length > 0) {
    const erroresIds = faltantes.map((ind) => ind.asignatura_salon_id);
    setErrores(erroresIds);
    setNotification({
      type: "error",
      message: "Debe diligenciar todos los indicadores antes de guardar.",
    });
    return;
  }

  setErrores([]);

  try {
    if (user?.rol_id === 2) {
      await createIndicadorData(indicadoresArray);
      setNotification({
        type: "success",
        message: "Indicadores guardados correctamente.",
      });
      // Recargar indicadores guardados
      await fetchIndicadoresBySalonYPeriodo(periodoId, salonGrado?.salon_id);
    } else {
      await updateIndicadorData(indicadoresGuardados[0]?.id, indicadoresArray);
      setNotification({
        type: "success",
        message: "Indicadores actualizados correctamente.",
      });
    }
  } catch (error) {
    console.error("Error al guardar indicadores:", error);
    setNotification({
      type: "error",
      message: error.response?.data?.message || "Error al guardar indicadores.",
    });
  }
};
  

  const handleDelete = async (periodoId, salonId) => {
    try {
      const response = await deleteIndicadorData(periodoId, salonId);
      const refreshed = await fetchIndicadoresBySalonYPeriodo(periodoId, salonId);
      setIndicadoresGuardados(refreshed);
      const updatedMap = {};
      refreshed.forEach((item) => {
        updatedMap[item.asignatura_id] = { id: item.id, descripcion: item.descripcion };
      });
      setIndicadores(updatedMap);
      setNotification({ type: "success", message: response.message || "Indicadores eliminados correctamente." });
    } catch (error) {
      setNotification({ type: "error", message: error.response?.data?.message || "Error al eliminar indicadores." });
    }
  };

  // Mostrar mensaje si no es preescolar
  if (user?.rol_id === 2 && salonGrado && !esPreescolar) {
    return (
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar />
        <div className="flex-1 p-6 overflow-y-auto">
          <HeaderPage title="Indicadores" />
          <div className="bg-white p-8 rounded-2xl shadow-md mt-10 flex flex-col items-center text-center">
            <p className="text-xl font-semibold max-w-md">
              Esta funcionalidad solo está disponible para grados de preescolar (Párvulos, Prejardín, Jardín, Transición).
            </p>
            <img
              src="/logo.png"
              alt="Logo Colegio"
              className="w-64 mb-4 drop-shadow-xl"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-6 overflow-y-auto">
        <HeaderPage title="Indicadores" />

        {loading ? (
          <p className="text-center text-xl font-semibold">Cargando...</p>
        ) : user?.rol_id === 1 ? (
          <IndicadoresViewer 
            periodos={periodos}
            salones={salones}
            periodoId={periodoId}
            setPeriodoId={setPeriodoId}
            salonId={salonId}
            setSalonId={setSalonId}
            asignaturasDelSalon={asignaturasDelSalon}
            indicadoresGuardados={indicadoresGuardados}
            setIndicadoresGuardados={setIndicadoresGuardados}
          />
        ) :(
          <>
            <IndicadoresForm
              periodos={periodos}
              periodoId={periodoId}
              setPeriodoId={setPeriodoId}
              asignaturasDelSalon={asignaturasDelSalon}
              indicadores={indicadores}
              indicadoresGuardados={indicadoresGuardados}
              errores={errores}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
              salonId={salonGrado?.salon_id}
            />
          </>
        )}

        {notification && (
          <Notification
            type={notification.type}
            message={notification.message}
            onClose={closeNotification}
          />
        )}
      </div>
    </div>
  );
};

export default IndicadoresPage;